import appConfig from 'app.config'
import { CustomerForm } from 'constants/enums/formTypes'
import { ApplicationMissingKycFormFi } from './forms/applicationMissingKycFormFi'
import { FormWrapper } from './formWrapper'
import { ApplicationMissingKycFormDk } from './forms/applicationMissingKycFormDk'
import { ApplicationMissingKycFormNo } from './forms/ApplicationMissingKycFormNo'
import {
	ApplicationPersonalInformationForm,
	ApplicationPersonalInformationFormDe,
	ApplicationPersonalInformationFormLt,
	// ApplicationPersonalInformationFormUK,
} from './forms/applicationPersonalInformationForm'
import {
	// ApplicationAccommodationFormUK,
	ApplicationAddressForm,
	ApplicationAddressFormDe,
	ApplicationAddressFormLt,
	// ApplicationAddressFormUK,
	// ApplicationFormerAddressFormUK,
} from './forms/applicationAddressForm'
import {
	ApplicationEmploymentForm,
	ApplicationEmploymentFormDe,
	// ApplicationEmploymentFormUK,
} from './forms/applicationEmploymentForm'
import { ApplicationExpensesForm } from './forms/applicationExpensesForm'
import { ApplicationMortgageForm } from './forms/applicationMortgageForm'
import {
	ApplicationContactInformationForm,
	// ApplicationContactInformationFormUK,
} from './forms/applicationContactInformationForm'
import {
	ApplicationBankInfoForm,
	ApplicationBankInfoFormFi,
	ApplicationBankInfoFormDk,
	ApplicationBankInfoFormLt,
	ApplicationBankInfoFormEsCreditCard,
	ApplicationBankInfoFormDe,
} from './forms/applicationBankInfoForm'
import {
	ApplicationLoanOfferForm,
	ApplicationLoanOfferFormDe,
	ApplicationLoanOfferFormLt,
} from './forms/applicationLoanOfferForm'
import { OtpCompleteForm } from './forms/otpCompleteForm'
import { ApplicationMissingKycFormSe } from './forms/ApplicationMissingKycFormSe'
import { InvolveSpouseFormLt } from './forms/involveSpouseForm'
import { UpdateSpouseFormLt } from './forms/updateSpouseForm'
import {
	OtpStartFormDe,
	OtpStartFormEs,
	OtpStartFormLt,
} from './forms/otpStartForm'
import { ProductType } from 'constants/enums/productTypes'
import { ApplicationDetailsFormUK } from './forms/ApplicationDetailsFormUK'
import { FinancialSituationFormUK } from './forms/FinancialFormUK'
import { NationalityFormUK } from './forms/NationalityFormUK'
import { ContactFormUK } from './forms/ContactFormUK'
import { CreditLimitPreferenceFormUK } from './forms/CreditLimitFormUK'
import { MarketingPreferenceFormUK } from './forms/MarketingPreferenceFormUK'

export function FormFactory(formType: CustomerForm, formMeta: any, data?: any) {
	const country = appConfig.country
	switch (formType) {
		case CustomerForm.ApplicationMissingKyc:
			if (country === 'fi')
				return FormWrapper(
					[ApplicationMissingKycFormFi(data)],
					formMeta,
				)
			if (country === 'dk')
				return FormWrapper(
					[ApplicationMissingKycFormDk(data)],
					formMeta,
				)
			if (country === 'no')
				return FormWrapper(
					[ApplicationMissingKycFormNo(data)],
					formMeta,
				)
			if (country === 'se')
				return FormWrapper(
					[ApplicationMissingKycFormSe(data)],
					formMeta,
				)
			break
		case CustomerForm.ApplicationPersonalInformationForm:
			if (country === 'es')
				return FormWrapper(
					[ApplicationPersonalInformationForm(data)],
					formMeta,
				)
			if (country === 'lt')
				return FormWrapper(
					[ApplicationPersonalInformationFormLt(data)],
					formMeta,
				)
			// if (country === 'uk')
			// 	return FormWrapper(
			// 		[ApplicationPersonalInformationFormUK(data)],
			// 		formMeta,
			// 	)
			break
		case CustomerForm.ApplicationAddressForm:
			if (country === 'es')
				return FormWrapper([ApplicationAddressForm(data)], formMeta)
			if (country === 'lt')
				return FormWrapper([ApplicationAddressFormLt(data)], formMeta)
			// if (country === 'uk')
			// 	return FormWrapper([ApplicationAddressFormUK(data)], formMeta)
			break
		// case CustomerForm.ApplicationFormerAddressForm:
		// 	if (country === 'uk')
		// 		return FormWrapper(
		// 			[ApplicationFormerAddressFormUK(data)],
		// 			formMeta,
		// 		)
		// 	break
		// case CustomerForm.ApplicationAccommodationForm:
		// 	if (country === 'uk')
		// 		return FormWrapper(
		// 			[ApplicationAccommodationFormUK(data)],
		// 			formMeta,
		// 		)
		// 	break
		case CustomerForm.ApplicationEmploymentForm:
			if (country === 'es')
				return FormWrapper([ApplicationEmploymentForm(data)], formMeta)
			// if (country === 'uk')
			// 	return FormWrapper(
			// 		[ApplicationEmploymentFormUK(data)],
			// 		formMeta,
			// 	)
			break
		case CustomerForm.ApplicationExpensesForm:
			return composeForm(
				[
					ApplicationExpensesForm(data),
					ApplicationMortgageForm(data),
					ApplicationContactInformationForm(data),
				],
				formMeta,
			)
		case CustomerForm.ApplicationContactInformationForm:
			if (country === 'es')
				return FormWrapper(
					[ApplicationContactInformationForm(data)],
					formMeta,
				)
			if (country === 'uk')
				return FormWrapper([ContactFormUK(data)], formMeta)
			break
		case CustomerForm.ApplicationCreditLimitForm:
			if (country === 'uk')
				return FormWrapper(
					[CreditLimitPreferenceFormUK(data)],
					formMeta,
				)
			break
		case CustomerForm.ApplicationFinancialForm:
			if (country === 'uk')
				return FormWrapper([FinancialSituationFormUK(data)], formMeta)
			break
		case CustomerForm.ApplicationMarketingPreferenceForm:
			if (country === 'uk')
				return FormWrapper([MarketingPreferenceFormUK(data)], formMeta)
			break
		case CustomerForm.ApplicationNationalityForm:
			if (country === 'uk')
				return FormWrapper([NationalityFormUK(data)], formMeta)
			break
		case CustomerForm.OtpStartForm:
			if (country === 'es')
				return FormWrapper([OtpStartFormEs(data)], formMeta)
			if (country === 'lt')
				return FormWrapper([OtpStartFormLt(data)], formMeta)
			if (country === 'de')
				return FormWrapper([OtpStartFormDe(data)], formMeta)
			break
		case CustomerForm.OtpCompleteForm:
			return FormWrapper([OtpCompleteForm(data)], formMeta)
		case CustomerForm.ApplicationLoanOfferForm:
			if (country === 'es')
				return FormWrapper([ApplicationLoanOfferForm(data)], formMeta)
			if (country === 'lt')
				return FormWrapper([ApplicationLoanOfferFormLt(data)], formMeta)
			if (country === 'de')
				return FormWrapper([ApplicationLoanOfferFormDe(data)], formMeta)
			break
		case CustomerForm.ApplicationBankInfoForm:
			if (country === 'es')
				return data?.product === ProductType.EspCreditCard
					? FormWrapper(
							[ApplicationBankInfoFormEsCreditCard(data)],
							formMeta,
						)
					: FormWrapper([ApplicationBankInfoForm(data)], formMeta)
			if (country === 'fi')
				return FormWrapper([ApplicationBankInfoFormFi(data)], formMeta)
			if (country === 'dk')
				return FormWrapper([ApplicationBankInfoFormDk(data)], formMeta)
			if (country === 'se')
				return FormWrapper([ApplicationBankInfoForm(data)], formMeta)
			if (country === 'lt')
				return FormWrapper([ApplicationBankInfoFormLt(data)], formMeta)
			break
		case CustomerForm.InvolveSpouseForm:
			return FormWrapper([InvolveSpouseFormLt(data)], formMeta)
		case CustomerForm.UpdateSpouseForm:
			return FormWrapper([UpdateSpouseFormLt(data)], formMeta)
		case CustomerForm.ApplicationUpdateForm:
			if (country === 'de')
				return composeForm(
					[
						ApplicationPersonalInformationFormDe(data),
						ApplicationEmploymentFormDe(data),
						ApplicationAddressFormDe(data),
						ApplicationBankInfoFormDe(data),
					],
					formMeta,
				)
			if (country === 'uk')
				return FormWrapper([ApplicationDetailsFormUK(data)], formMeta)
			break
		default:
			return Object.assign({})
	}
}

const composeForm = (formPartials: any, formMeta: any) => {
	return FormWrapper(formPartials, formMeta)
}
